/**
 * Display an error message to the user
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

function willDismiss(props) {
    return props.removeTimeout && props.onRemove;
}

class Broadcast extends Component {
    static propTypes = {
        onRemove: PropTypes.func,
        removeTimeout: PropTypes.number,
        className: PropTypes.string,
        children: PropTypes.node,
    };

    componentDidMount() {
        if (willDismiss(this.props)) {
            this.removeTimeout = setTimeout(
                this.props.onRemove,
                this.props.removeTimeout
            );
        }
    }

    componentWillUnmount() {
        if (this.removeTimeout) {
            clearTimeout(this.removeTimeout);
        }
    }

    onRemoveClick(e) {
        e.preventDefault();
        this.props.onRemove();
    }

    renderRemoveBtn() {
        return (
            <a
                className="mls licorice fright-ht768"
                href="#"
                onClick={this.onRemoveClick.bind(this)}
            >
                &times;
            </a>
        );
    }

    render() {
        let removeBtn = null;

        if (this.props.onRemove) {
            removeBtn = this.renderRemoveBtn();
        }

        return (
            <div
                className={cx('mas', this.props.className)}
                style={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}
            >
                {this.props.children}
                {removeBtn}
            </div>
        );
    }
}

export default Broadcast;
